import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Icon,
  Input,
  Row,
  Select,
  Typography,
} from 'antd';

import CronRunsTable from './CronRunsTable';
import { fetchCronRunsAction } from '../../containers/EngagementCaseReport/actions';
import './engagement-case-report.scss';

const { Option } = Select;
const { MonthPicker } = DatePicker;
const { Title } = Typography;

const PAGE_SIZE = 10;

const STATUS_OPTIONS = ['success', 'failed', 'running'];
const TRIGGER_SOURCE_OPTIONS = ['system', 'manual'];

const CronRunHistory = ({
  fetchCronRuns,
  cronRuns,
  cronRunsTotal,
  cronRunsPage,
  cronRunsLoading,
}) => {
  const [hubId, setHubId] = useState('');
  const [monthValue, setMonthValue] = useState(null);
  const [status, setStatus] = useState();
  const [triggerSource, setTriggerSource] = useState();
  const [filtersPage, setFiltersPage] = useState(1);

  const buildFetchPayload = (page = 1) => {
    const hubIdNum = hubId ? parseInt(hubId, 10) : undefined;
    const monthKey = monthValue ? monthValue.format('YYYY-MM') : undefined;
    return {
      page,
      pageSize: PAGE_SIZE,
      ...(hubIdNum && !Number.isNaN(hubIdNum) && { hubId: hubIdNum }),
      ...(monthKey && { monthKey }),
      ...(status && { status }),
      ...(triggerSource && { triggerSource }),
    };
  };

  const handleApplyFilters = (page = 1) => {
    setFiltersPage(page);
    fetchCronRuns(buildFetchPayload(page));
  };

  const handleClearFilters = () => {
    setHubId('');
    setMonthValue(null);
    setStatus(undefined);
    setTriggerSource(undefined);
    setFiltersPage(1);
    fetchCronRuns({ page: 1, pageSize: PAGE_SIZE });
  };

  const isFilterActive =
    hubId.length > 0 || monthValue || status || triggerSource;

  useEffect(() => {
    fetchCronRuns({ page: 1, pageSize: PAGE_SIZE });
  }, [fetchCronRuns]);

  return (
    <>
      <Divider className="engagement-case-report__section-divider" />
      <Title level={4}>Case cron Run history</Title>
      <Row type="flex" gutter={10} align="middle">
        <Col span={4}>
          <Input
            placeholder="Hub ID"
            value={hubId}
            onChange={e => setHubId(e.target.value)}
            allowClear
          />
        </Col>
        <Col span={4}>
          <MonthPicker
            format="YYYY-MM"
            placeholder="Month"
            value={monthValue}
            onChange={setMonthValue}
            style={{ width: '100%' }}
            allowClear
          />
        </Col>
        <Col span={5}>
          <Select
            placeholder="Status"
            value={status}
            onChange={setStatus}
            style={{ width: '100%' }}
            allowClear
          >
            {STATUS_OPTIONS.map(value => (
              <Option key={value} value={value}>
                {value}
              </Option>
            ))}
          </Select>
        </Col>
        <Col span={5}>
          <Select
            placeholder="Trigger source"
            value={triggerSource}
            onChange={setTriggerSource}
            style={{ width: '100%' }}
            allowClear
          >
            {TRIGGER_SOURCE_OPTIONS.map(value => (
              <Option key={value} value={value}>
                {value}
              </Option>
            ))}
          </Select>
        </Col>
        <Col style={{ marginLeft: 'auto', flex: '0 0 auto' }}>
          <Button
            type="primary"
            disabled={!isFilterActive}
            onClick={() => handleApplyFilters()}
            style={{ marginRight: 8 }}
          >
            <Icon type="filter" />
            Apply
          </Button>
          <Button disabled={!isFilterActive} onClick={handleClearFilters}>
            <Icon type="sync" />
            Clear
          </Button>
        </Col>
      </Row>
      <div style={{ marginTop: 16 }}>
        <CronRunsTable
          runs={cronRuns}
          total={cronRunsTotal}
          loading={cronRunsLoading}
          page={filtersPage || cronRunsPage}
          onPageChange={page => handleApplyFilters(page)}
        />
      </div>
    </>
  );
};

const mapStateToProps = ({
  engagementCaseReport: {
    cronRuns,
    cronRunsTotal,
    cronRunsPage,
    cronRunsLoading,
  },
}) => ({
  cronRuns,
  cronRunsTotal,
  cronRunsPage,
  cronRunsLoading,
});

const mapDispatchToProps = {
  fetchCronRuns: fetchCronRunsAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(CronRunHistory);
